<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { mapState } from "vuex";
import moment from "moment";
import Calendar from 'primevue/calendar';
import Stat from "@/components/widgets/stat";
import ChartGraduation from "@/components/widgets/chart-graduation.vue";
import ChartBoletos from "@/components/widgets/chart-boletos.vue";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
    Calendar,
    Stat,
    ChartGraduation,
    ChartBoletos,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
      month_year: moment().format("M/YYYY"),

      statData: null,

      regional: "all",
      periodMonth: new Date(),

      total: {
        prediction: "R$ -,--",
      },

      ranking: {
        adesoes: {
          qty: "-",
          list: null,
        },
        boletospagos: {
          qty: "-",
          total: "R$ -,--",
          list: null,
        },
        primeiroboletopago: {
          qty: "-",
          total: "R$ -,--",
          list: null,
        },
        primeiroboletoemaberto: {
          qty: "-",
          total: "R$ -,--",
          list: null,
        },
        inadimplencia: {
          qty: "-",
          total: "R$ -,--",
          list: null,
        },
        ticketmedio: {
          geral: "R$ -,--",
          media: "R$ -,--",
          list: null,
        }
      }
    };
  },
  methods: {
    getPeriod() {
      if (this.periodMonth) {
        const date = [
          new Date(this.periodMonth).getFullYear(),
          new Date(this.periodMonth).getMonth() + 1
        ];

        return date.join('-');
      } else {
        const date = [
          new Date().getFullYear(),
          new Date().getMonth() + 1
        ];

        return date.join('-');
      }
    },
    showPeriod() {
      if (this.periodMonth) {
        const date = [
          new Date(this.periodMonth).getMonth() + 1,
          new Date(this.periodMonth).getFullYear()
        ];

        return date.join('/');
      } else {
        const date = [
          new Date().getMonth() + 1,
          new Date().getFullYear()
        ];

        return date.join('/');
      }
    },
    getPrediction() {
      this.total.prediction = "R$ -,--";

      api
        .get('reports/bonus/prediction?date=' + this.getPeriod())
        .then(response => {
          if (response.data.status == 'success') {
            this.total.prediction = this.$options.filters.currency(response.data.total);

            this.getStatData();
          }
        })
    },
    getAdesoes() {
      this.ranking.adesoes.qty = "-";
      this.ranking.adesoes.list = null;

      api
        .get('ranking/adesoes?date=' + this.getPeriod())
        .then(response => {
          if (response.data.status == 'success') {
            this.ranking.adesoes.qty = this.$options.filters.points(response.data.qty);
            this.ranking.adesoes.list = response.data.list;

            this.getStatData();
          }
        })
    },
    getBoletosPagos() {
      this.ranking.boletospagos.qty = "-";
      this.ranking.boletospagos.total = "R$ -,--";
      this.ranking.boletospagos.list = null;

      api
        .get('ranking/boletospagos?date=' + this.getPeriod() + '&regional=' + this.regional)
        .then(response => {
          if (response.data.status == 'success') {
            this.ranking.boletospagos.qty = this.$options.filters.points(response.data.qty);
            this.ranking.boletospagos.total = this.$options.filters.currency(response.data.total);
            this.ranking.boletospagos.list = response.data.list;

            this.getStatData();
          }
        })
    },
    getPrimeiroBoletoPago() {
      this.ranking.primeiroboletopago.qty = "-";
      this.ranking.primeiroboletopago.total = "R$ -,--";
      this.ranking.primeiroboletopago.list = null;

      api
        .get('ranking/primeiroboletopago?date=' + this.getPeriod() + '&regional=' + this.regional)
        .then(response => {
          if (response.data.status == 'success') {
            this.ranking.primeiroboletopago.qty = this.$options.filters.points(response.data.qty);
            this.ranking.primeiroboletopago.total = this.$options.filters.currency(response.data.total);
            this.ranking.primeiroboletopago.list = response.data.list;

            this.getStatData();
          }
        })
    },
    getPrimeiroBoletoEmAberto() {
      this.ranking.primeiroboletoemaberto.qty = "-";
      this.ranking.primeiroboletoemaberto.total = "R$ -,--";
      this.ranking.primeiroboletoemaberto.list = null;

      api
        .get('ranking/primeiroboletoemaberto?date=' + this.getPeriod() + '&regional=' + this.regional)
        .then(response => {
          if (response.data.status == 'success') {
            this.ranking.primeiroboletoemaberto.qty = this.$options.filters.points(response.data.qty);
            this.ranking.primeiroboletoemaberto.total = this.$options.filters.currency(response.data.total);
            this.ranking.primeiroboletoemaberto.list = response.data.list;

            this.getStatData();
          }
        })
    },
    getTicketMedio() {
      this.ranking.ticketmedio.geral = "R$ -,--";
      this.ranking.ticketmedio.media = "R$ -,--";
      this.ranking.ticketmedio.list = null;

      api
        .get('ranking/ticketmedio?date=' + this.getPeriod() + '&regional=' + this.regional)
        .then(response => {
          if (response.data.status == 'success') {
            this.ranking.ticketmedio.geral = this.$options.filters.currency(response.data.geral);
            this.ranking.ticketmedio.media = this.$options.filters.currency(response.data.media);
            this.ranking.ticketmedio.list = response.data.list;

            this.getStatData();
          }
        })
    },
    getStatData() {
      this.statData = [
        {
          type: "line",
          icon: "bx-user",
          color: "",
          title: "Tipo de Conta",
          value: this.account.user.package,
        },
        {
          type: "line",
          icon: "bxs-graduation",
          color: "",
          title: "Qualificação do Mês",
          value: "-",
        },
        {
          type: "line",
          icon: "bxs-car-wash",
          color: "",
          title: "Adesões do Mês",
          value: "<span>" + this.ranking.adesoes.qty + "</span>"
        },
        {
          type: "line",
          icon: "bx-calendar",
          color: "",
          title: "Previsão do Mês",
          value: this.total.prediction,
        },
        {
          type: "line",
          icon: "bx-barcode",
          color: "success",
          title: "Boletos Pagos",
          value: "<span>" + this.ranking.boletospagos.total + "</span><span>" + this.ranking.boletospagos.qty + "</span>",
        },
        {
          type: "line",
          icon: "bx-user-plus",
          color: "success",
          title: "1º Boleto Pago",
          value: "<span>" + this.ranking.primeiroboletopago.total + "</span><span>" + this.ranking.primeiroboletopago.qty + "</span>"
        },
        {
          type: "line",
          icon: "bx-dollar-circle",
          color: "danger",
          title: "1º Boleto em Aberto",
          value: "<span>" + this.ranking.primeiroboletoemaberto.qty + "</span>"
        },
        {
          type: "line",
          icon: "bx-dollar",
          color: "success",
          title: "Ticket Médio",
          value: "<span>" + this.ranking.ticketmedio.geral + "</span>"
        },
      ]
    },
  },
  mounted() {
    this.getPrediction()
    this.getAdesoes()
    this.getBoletosPagos()
    this.getPrimeiroBoletoPago()
    this.getPrimeiroBoletoEmAberto()
    this.getTicketMedio()
    this.getStatData()
  },
  watch: {
    'regional': function () {
      this.getPrediction()
      this.getAdesoes()
      this.getBoletosPagos()
      this.getPrimeiroBoletoPago()
      this.getPrimeiroBoletoEmAberto()
      this.getTicketMedio()
      this.getStatData()
    },
    'periodMonth': function () {
      this.month_year = this.showPeriod();

      this.getPrediction()
      this.getAdesoes()
      this.getBoletosPagos()
      this.getPrimeiroBoletoPago()
      this.getPrimeiroBoletoEmAberto()
      this.getTicketMedio()
      this.getStatData()
    },
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">APVS Brasil Brasil</li>
      <li class="breadcrumb-item d-none d-sm-block">Dashboard</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Dashboard</h3>
        <p></p>
      </div>

      <div class="filter-bar d-flex mb-4">
        <b-dropdown right variant="outline-light">
          <template #button-content>
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="m-0 text-secondary">filtrar período</h6>
                <div>{{ showPeriod() }}</div>
              </div>
              <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
              </svg>
            </div>
          </template>
          <b-dropdown-group>
            <Calendar v-model="periodMonth" view="month" dateFormat="yy-mm-dd" inline>
            </Calendar>
          </b-dropdown-group>
        </b-dropdown>
        <b-dropdown variant="outline-light" class="d-none">
          <template #button-content>
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="m-0 text-secondary">Equipe</h6>
                <div v-if="regional == 'all'">Toda rede</div>
                <div v-else-if="regional == 'team'">Minha regional</div>
              </div>
              <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
              </svg>
            </div>
          </template>
          <b-dropdown-form><b-form-radio v-model="regional" value="all">Toda rede</b-form-radio></b-dropdown-form>
          <b-dropdown-form><b-form-radio v-model="regional" value="team">Minha regional</b-form-radio></b-dropdown-form>
        </b-dropdown>
      </div>
    </div>

    <div class="row">
      <div v-for="(row, index) of statData" :key="index" class="col-md-3 col-lg-3 col-xl-3">
        <Stat :type="row.type" :icon="row.icon" :color="row.color" :month="row.month" :title="row.title" :value="row.value" />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <fieldset class="card-h-fix">
          <legend>
            Qualificação do Mês <sup class="font-weight-light">{{ month_year }}</sup>
          </legend>
          <div class="d-flex justify-content-center card-h-fix">
            <ChartGraduation />
          </div>
        </fieldset>
      </div>
      <div class="col-md-6">
        <fieldset class="card-h-fix">
          <legend>Boletos <sup class="font-weight-light">{{ month_year }}</sup></legend>
          <div class="d-flex flex-wrap flex-gap-10 mb-4">
            <div class="flex-fill" v-if="this.ranking.boletospagos.total && this.ranking.boletospagos.qty">
              <div class="card mb-0">
                <div class="card-body text-center p-2">
                  <div class="">
                    <h5 class="my-1">{{ this.ranking.boletospagos.total}}</h5>
                    <h5 class="my-1">{{ this.ranking.boletospagos.qty }}</h5>
                  </div>
                  <div class="bg-light rounded py-1 font-size-12 text-uppercase">Boletos Pagos</div>
                </div>
              </div>
            </div>
            <div class="flex-fill" v-if="this.ranking.primeiroboletopago.total && this.ranking.primeiroboletopago.qty">
              <div class="card mb-0">
                <div class="card-body text-center p-2">
                  <div class="">
                    <h5 class="my-1">{{ this.ranking.primeiroboletopago.total }}</h5>
                    <h5 class="my-1">{{ this.ranking.primeiroboletopago.qty }}</h5>
                  </div>
                  <div class="bg-light rounded py-1 font-size-12 text-uppercase">1º Boleto Pago</div>
                </div>
              </div>
            </div>
          </div>

          <ChartBoletos></ChartBoletos>
        </fieldset>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <fieldset class="card-h-fix">
          <legend>Adesões <sup class="font-weight-light">{{ month_year }}</sup></legend>
          <div class="d-flex flex-wrap flex-gap-10 mb-4">
            <div class="flex-fill" v-if="this.ranking.adesoes.qty">
              <div class="card mb-0">
                <div class="card-body text-center p-2">
                  <h5 class="my-1">{{ this.ranking.adesoes.qty }}</h5>
                  <div class="bg-light rounded py-1 font-size-12 text-uppercase">Qtd</div>
                </div>
              </div>
            </div>
            <div class="d-none flex-fill" v-if="this.ranking.adesoes.total">
              <div class="card mb-0">
                <div class="card-body text-center p-2">
                  <h5 class="my-1">{{ this.ranking.adesoes.total }}</h5>
                  <div class="bg-light rounded py-1 font-size-12 text-uppercase">Total</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!ranking.adesoes.list" class="text-center">
            <b-spinner class="align-middle" variant="default" role="status"></b-spinner>
          </div>
          <div v-else>
            <div class="d-flex flex-gap-10 justify-content-between align-items-center mb-2" v-for="(row, index) of ranking.adesoes.list" :key="index">
              <div class="d-flex flex-gap-10 align-items-center ranking-row-name">
                <span class="ranking-bullet">{{ index + 1 }}</span>
                <span>{{ row.name }}</span>
              </div>
              <div class="d-flex flex-gap-10">
                <span class="badge badge-soft-light font-size-13 text-default">{{ row.qty | points }}</span>
                <span class="d-none">{{ row.total | currency }}</span>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="col-md-6">
        <fieldset class="card-h-fix">
          <legend>Boletos Pagos <sup class="font-weight-light">{{ month_year }}</sup></legend>
          <div class="d-flex flex-wrap flex-gap-10 mb-4">
            <div class="flex-fill">
              <div class="card mb-0">
                <div class="card-body text-center p-2">
                  <h5 class="my-1">{{ this.ranking.boletospagos.qty }}</h5>
                  <div class="bg-light rounded py-1 font-size-12 text-uppercase">Qtd</div>
                </div>
              </div>
            </div>
            <div class="flex-fill">
              <div class="card mb-0">
                <div class="card-body text-center p-2">
                  <h5 class="my-1">{{ this.ranking.boletospagos.total }}</h5>
                  <div class="bg-light rounded py-1 font-size-12 text-uppercase">Total</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!ranking.boletospagos.list" class="text-center">
            <b-spinner class="align-middle" variant="default" role="status"></b-spinner>
          </div>
          <div v-else>
            <div class="d-flex flex-gap-10 justify-content-between align-items-center mb-2" v-for="(row, index) of ranking.boletospagos.list" :key="index">
              <div class="d-flex flex-gap-10 align-items-center ranking-row-name">
                <span class="ranking-bullet">{{ index + 1}}</span>
                <span>{{ row.name }}</span>
              </div>
              <div class="d-flex flex-gap-10">
                <span class="badge badge-soft-light font-size-13 text-default">{{ row.qty | points }}</span>
                <span>{{ row.total | currency }}</span>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="col-md-6">
        <fieldset class="card-h-fix">
          <legend>1º Boleto em Aberto <sup class="font-weight-light">{{ month_year }}</sup></legend>
          <div class="d-flex flex-wrap flex-gap-10 mb-4">
            <div class="flex-fill">
              <div class="card mb-0">
                <div class="card-body text-center p-2">
                  <h5 class="my-1">{{ this.ranking.primeiroboletoemaberto.qty }}</h5>
                  <div class="bg-light rounded py-1 font-size-12 text-uppercase">Qtd</div>
                </div>
              </div>
            </div>
            <div class="d-none flex-fill">
              <div class="card mb-0">
                <div class="card-body text-center p-2">
                  <h5 class="my-1">{{ this.ranking.primeiroboletoemaberto.total }}</h5>
                  <div class="bg-light rounded py-1 font-size-12 text-uppercase">Total</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!ranking.primeiroboletoemaberto.list" class="text-center">
            <b-spinner class="align-middle" variant="default" role="status"></b-spinner>
          </div>
          <div v-else>
            <div class="d-flex flex-gap-10 justify-content-between align-items-center mb-2" v-for="(row, index) of ranking.primeiroboletoemaberto.list" :key="index">
              <div class="d-flex flex-gap-10 align-items-center ranking-row-name">
                <span class="ranking-bullet">{{ index + 1 }}</span>
                <span>{{ row.name }}</span>
              </div>
              <div class="d-flex flex-gap-10">
                <span class="badge badge-soft-light font-size-13 text-default">{{ row.qty | points }}</span>
                <span class="d-none">{{ row.total | currency }}</span>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="col-md-6">
        <fieldset class="card-h-fix">
          <legend>Ticket Médio Top 50 <sup class="font-weight-light">{{ month_year }}</sup></legend>
          <div class="d-flex flex-wrap flex-gap-10 mb-4">
            <div class="flex-fill">
              <div class="card mb-0">
                <div class="card-body text-center p-2">
                  <h5 class="my-1">{{ ranking.ticketmedio.media }}</h5>
                  <div class="bg-light rounded py-1 font-size-12 text-uppercase">Valor Médio</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!ranking.ticketmedio.list" class="text-center">
            <b-spinner class="align-middle" variant="default" role="status"></b-spinner>
          </div>
          <div v-else>
            <div class="d-flex flex-gap-10 justify-content-between align-items-center mb-2" v-for="(row, index) of ranking.ticketmedio.list" :key="index">
              <div class="d-flex flex-gap-10 align-items-center ranking-row-name">
                <span class="ranking-bullet">{{ index + 1 }}</span>
                <span>{{ row.name }}</span>
              </div>
              <div class="d-flex flex-gap-10">
                <span>{{ row.avg | currency }}</span>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.ranking-bullet {
  background: var(--st-brand);
  border-radius: 100%;
  padding: 2px;
  width: 25px;
  height: 25px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  /* A linha do ranking é um flex com `justify-content: space-between`. Sem
     `flex-shrink: 0`, num nome longo em tela de 380px o marcador era
     espremido e o círculo virava uma elipse. */
  flex: 0 0 25px;
  line-height: 21px;
}

/* O bloco "marcador + nome" precisa poder encolher (`min-width: 0`) para o
   nome quebrar em duas linhas em vez de empurrar o badge de pontos para
   fora da linha. */
.ranking-row-name {
  min-width: 0;
  flex: 1 1 auto;
}

.ranking-row-name > span:last-child {
  min-width: 0;
  overflow-wrap: anywhere;
}
</style>